import { MessageSquare } from "lucide-react";

/**
 * UnreadBadge — small orange pill showing unread message count for a claim row.
 * Returns null when count is 0 / falsy.
 */
export default function UnreadBadge({ count, claimId }) {
  if (!count) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-[#C25934] text-[#F9F8F6] leading-none"
      data-testid={`unread-badge-${claimId}`}
      title={`${count} unread message${count === 1 ? "" : "s"}`}
    >
      <MessageSquare className="w-3 h-3" />
      {count}
    </span>
  );
}
